import { Link } from "react-router-dom";
import { Award } from "lucide-react";
import { Card, Empty } from "../panel/PanelShell";
import CertificateActions from "../learning/CertificateActions";
import { certImage, useLearning } from "../../lib/learning";
import { fmtDate } from "../../lib/format";

export default function CertificatesTab() {
  const { certificates } = useLearning();
  const rows = Object.values(certificates).sort((a, b) => b.issued_at.localeCompare(a.issued_at));
  if (!rows.length)
    return (
      <div className="space-y-4">
        <Empty text="Finish every lesson of a course to earn your first Quantora certificate." testid="certificates-empty" />
        <Link to="/learn" data-testid="certificates-browse-btn" className="inline-flex rounded-full bg-mint px-5 py-2.5 text-sm font-semibold text-navy">Browse courses</Link>
      </div>
    );
  return (
    <div className="space-y-5" data-testid="certificates-list">
      {rows.map((c) => (
        <Card key={c.id} className="grid gap-6 md:grid-cols-[280px_1fr]" data-testid={`certificate-card-${c.id}`}>
          <Link to={`/certificates/${c.id}`} data-testid={`certificate-view-${c.id}`}><img src={certImage(c.id, "og", c.version)} alt={c.course_title} loading="lazy" className="w-full rounded-xl border border-slate-200" /></Link>
          <div>
            <p className="flex items-center gap-2 text-xs font-semibold uppercase tracking-wider text-gold-600"><Award size={14} /> {c.course_level} · {c.id}</p>
            <h3 className="mt-2 text-lg font-bold text-navy">{c.course_title}</h3>
            <p className="text-sm text-slate-500">Issued to {c.recipient_name} on {fmtDate(c.issued_at)}</p>
            <div className="mt-5"><CertificateActions cert={c} compact /></div>
          </div>
        </Card>
      ))}
    </div>
  );
}
